export default __webpack_public_path__ + "static/media/mariog14.cc6e22cb.jpg";